module.exports = __webpack_public_path__ + "static/media/Vaishnodevi_Heights.acfba829.pdf";